export const useCurrentOfferActions = () => {
  const { offerAPI, housingAPI } = useBackendRequests();
  const currentOffer = useCurrentOfferState();

  async function refresh() {
    if (!currentOffer) {
      return;
    }
    const response = await offerAPI.getByHousingId(currentOffer.value.housing.id);
    currentOffer.value = response.offer;
  }

  async function setInterest(value: boolean | null) {
    if (!currentOffer) {
      return;
    }
    let payload = '';
    if (value === true) {
      payload = 'yes';
    }
    if (value === false) {
      payload = 'no';
    }
    const response = await offerAPI.setInterest(currentOffer.value.targetUserId, payload as 'yes' | 'no' | '');
    currentOffer.value.actions = response.linkActions;
    return response;
  }

  async function setWatchStatus(value: boolean) {
    if (value) {
      const response = await offerAPI.startWatching(currentOffer.value.targetUserId);
      currentOffer.value.actions = response.linkActions;
      return response;
    } else {
      const response = await offerAPI.stopWatching(currentOffer.value.targetUserId);
      currentOffer.value.actions = response.linkActions;
      return response;
    }
  }

  function trackView() {
    return housingAPI.saveView(currentOffer.value.housing.id);
  }

  return {
    refresh,
    trackView,
    setInterest,
    setWatchStatus,
  };
};
